(function () {
    'use strict';
    var NewMessageBaseCtrl = function (returnRoute, returnOpts) {
        return function ($scope, $q, PatientPortalStorageRepository, MessageRepository, ListService, gettext, TransitionManager, toaster, MyMessagesService, MyMessagesRepository, GuidList) {
            $scope.loading = false;
            $scope.sending = false;
            $scope.patientAttachmentSubtype = GuidList.MessageSubType.PatientAttachment;

            $scope.messageSettings = null;
            $scope.messageSubTypes = null;

            $scope.routeTypeString = null;

            $scope.portalMessage = {
                UrgencyId: null,
                RouteType: 'Service Site',
                ProviderOrServiceSiteId: null,
                SubTypeId: null,
                Header: '',
                Message: ''
            };

            $scope.AttachmentList=
            {
               attachmentDtoList : $scope.attachmentDtoList,
                validationMessage : ''
            };

            $scope.returnRoute = returnRoute;
            $scope.returnOpts = returnOpts;

            var activePatient = PatientPortalStorageRepository.getActivePatient();

            function getUrgencyList() {
                return ListService.getList('urgencies')
                    .then(function (urgencyList) {
                        $scope.urgencies = urgencyList;
                        var defaultUrgency = _.find(urgencyList, {IsDefault: true});
                        if (!_.isUndefined(defaultUrgency)) {
                            $scope.portalMessage.UrgencyId = defaultUrgency.Id;
                        }
                    });
            }


            function getMessageSettings() {
                return MyMessagesService.getMessageSettings(activePatient.id)
                    .then(function (data) {
                        $scope.messageSettings = data;
                    });
            }

            function getAttachmentConfig()
            {
               return MyMessagesService.isAttachmentAllowed();
            }

            function loadView() {
                $scope.loading = true;
                $scope.removeHttpError();
                var urgencyListPromise = getUrgencyList();
                var messageSettingsPromise = getMessageSettings();

                $q.all([urgencyListPromise, messageSettingsPromise]).then(function () {
                    MessageRepository.getPortalMessageMetadata($scope);

                    if ($scope.messageSettings && $scope.messageSettings.length > 0) {
                        $scope.portalMessage.RouteType = $scope.messageSettings[0].RouteType;
                        if ($scope.messageSettings[0].RouteType.toLowerCase() === 'practice') {
                            $scope.routeTypeString = gettext('Practice');
                        } else if ($scope.messageSettings[0].RouteType.toLowerCase() === 'servicesite') {
                            $scope.routeTypeString = gettext('Service Site');
                        } else if ($scope.messageSettings[0].RouteType.toLowerCase() === 'provider'){
                            $scope.routeTypeString = gettext('Provider');
                        } else {
                            $scope.routeTypeString = gettext('Unknown');
                        }

                        var defaultSettingsItem = _($scope.messageSettings)
                            .filter({'DefaultRoutingItem': true})
                            .value();

                        if (defaultSettingsItem && defaultSettingsItem.length > 0) {
                            defaultSettingsItem = defaultSettingsItem[0];
                        }
                        else {
                            defaultSettingsItem = $scope.messageSettings[0];
                        }

                        $scope.portalMessage.ProviderOrServiceSiteId = defaultSettingsItem.ProviderOrServiceSiteId;

                        $scope.messageSubTypes = _(defaultSettingsItem.MessageSubTypes)
                            .filter({'SystemMessage': false, 'Enabled': true})
                            .value();

                        if ($scope.messageSubTypes && $scope.messageSubTypes.length > 0) {
                            var defaultItem = _.find($scope.messageSubTypes, {Id: '9af1089b-e98b-4758-80f8-0435b143426d'});
                            $scope.portalMessage.SubTypeId = (defaultItem) ? defaultItem.Id : $scope.messageSubTypes[0].Id;

                            if(!getAttachmentConfig()) {
                                $.each($scope.messageSubTypes, function (i) {
                                    if ($scope.messageSubTypes[i].Id === '584c539b-2874-44c9-9f86-6f0902044f5e'){
                                        $scope.messageSubTypes.splice(i, 1);
                                        return false;
                                    }
                                });
                            }
                        }
                    }
                }).catch(function (response) {
                    $scope.addHttpError(response, '', 'listData');
                }).finally(function () {
                    $scope.loading = false;
                });
            }

            $scope.selectedProviderOrServiceSiteChanged = function selectedProviderOrServiceSiteChanged() {
                var selectedMessageSettingsItem = _($scope.messageSettings)
                    .filter({'ProviderOrServiceSiteId': $scope.portalMessage.ProviderOrServiceSiteId})
                    .value();

                if (selectedMessageSettingsItem && selectedMessageSettingsItem.length) {
                    $scope.messageSubTypes = _(selectedMessageSettingsItem[0].MessageSubTypes)
                        .filter({'SystemMessage': false, 'Enabled': true})
                        .value();

                    if ($scope.messageSubTypes && $scope.messageSubTypes.length > 0) {
                        $scope.portalMessage.SubTypeId = $scope.messageSubTypes[0].Id;
                    }
                }
            };


            $scope.sendMessage = function sendMessage(form) {
                form.isSubmitted = true;

                if($scope.portalMessage.SubTypeId === '584c539b-2874-44c9-9f86-6f0902044f5e' && $scope.AttachmentList.attachmentDtoList.length === 0)
                {
                    $scope.AttachmentList.validationMessage = '* Please select an attachment to send. ';
                    form.$valid = false;
                }
                if (form.$valid) {
                    $scope.sending = true;

                    var selectedMessageSubType = _.find($scope.messageSubTypes, {Id: $scope.portalMessage.SubTypeId});

                    var newMessage = {
                        PatientId: activePatient.id,
                        UrgencyId: $scope.portalMessage.UrgencyId,
                        ProviderOrServiceSiteId: $scope.portalMessage.ProviderOrServiceSiteId,
                        RouteType: $scope.portalMessage.RouteType,
                        SubTypeId: $scope.portalMessage.SubTypeId,
                        Header: selectedMessageSubType.Name + ' - ' + $scope.portalMessage.Header,
                        Message: MyMessagesService.replaceLineBreaksWithHtmlLineBreak($scope.portalMessage.Message),
                        Status: 'Incomplete',
                        AttachmentDto : $scope.AttachmentList.attachmentDtoList
                    };

                    MyMessagesRepository
                        .createMessage(activePatient.id, newMessage)
                        .then(function () {
                            TransitionManager.transition({appRoute: returnRoute, opts: returnOpts });
                            toaster.pop('success', '', gettext('Message sent successfully.'));
                        })
                        .catch(function () {
                            toaster.pop('error', '', gettext('An error has occurred and the Message was not sent.'));
                        })
                        .finally(function () {
                            $scope.sending = false;
                        });
                }
            };

            loadView();
        };
    };

    var NewMessageCtrl = new NewMessageBaseCtrl('myMessagesDisplayMessages', { displayMode: 'received' });
    var NewMessageMobileCtrl = new NewMessageBaseCtrl('myMessagesMobile', { folder: 'inbox' });
    angular.module('mymessages').controller('NewMessageCtrl',
        ['$scope', '$q', 'PatientPortalStorageRepository', 'MessageRepository', 'ListService', 'aprgettext', 'TransitionManager', 'toaster', 'MyMessagesService', 'MyMessagesRepository', 'GuidList',
            NewMessageCtrl]);
    angular.module('mymessages').controller('NewMessageMobileCtrl',
        ['$scope', '$q', 'PatientPortalStorageRepository', 'MessageRepository', 'ListService', 'aprgettext', 'TransitionManager', 'toaster', 'MyMessagesService', 'MyMessagesRepository', 'GuidList',
            NewMessageMobileCtrl]);
})();